export default __webpack_public_path__ + "static/media/partners19.2573b6aa.png";